module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Survey Evaluation"},"de":{"title":"Umfragen"},"fr":{"title":"Evaluation du sondage"},"it":{"title":"Valutazione del sondaggio"}}')
  delete Component.options._Ctor
}
